import {alpha} from '@instructure/ui-color-utils'

const generateComponentTheme = variables => {
  return {
    focusBorderColor: variables['ic-brand-primary'],
    focusOutlineColor: alpha(variables['ic-brand-primary'], 50),
  }
}

export default generateComponentTheme
